// extracted by mini-css-extract-plugin
export default {"headerInfo":"CompetencyAndArchetypeTipModal_headerInfo__scELD","link":"CompetencyAndArchetypeTipModal_link__uSSG1"};